import { motion } from 'framer-motion';
import { ArrowRight, BarChart3, Building2, MailCheck, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { businessContent } from '../../lib/marketingContent';

const businessFeatures = [
  { icon: Building2, label: 'Espace organisation' },
  { icon: MailCheck, label: 'Invitations et relances' },
  { icon: BarChart3, label: 'Statuts agreges' },
  { icon: ShieldCheck, label: 'Donnees sensibles protegees' },
];

export const BusinessPreviewSection = () => {
  const { isDark } = useTheme();
  const navigate = useNavigate();

  return (
    <section
      id="business"
      className={`py-20 md:py-24 ${isDark ? 'bg-black' : 'bg-white'}`}
      data-testid="business-preview-section"
    >
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-[1.1fr_0.9fr] gap-10 items-center">
        <div>
          <p className="text-[#81d8d0] text-sm font-semibold mb-3">{businessContent.title}</p>
          <h2 className={`text-3xl md:text-5xl font-semibold tracking-tight mb-5 ${isDark ? 'text-white' : 'text-[#1d1d1f]'}`}>
            Une version pour les organisations qui accompagnent des publics.
          </h2>
          <p className={`text-lg leading-8 mb-7 ${isDark ? 'text-[#94A3B8]' : 'text-gray-600'}`}>
            {businessContent.promise}
          </p>
          <button
            type="button"
            onClick={() => navigate('/business')}
            className="btn-apple btn-apple-primary group"
            data-testid="business-preview-cta"
          >
            Voir Skipya Business
            <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>

        <motion.div
          className={`rounded-3xl border p-6 ${isDark ? 'bg-white/5 border-white/10' : 'bg-[#F8F7F4] border-gray-200'}`}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
        >
          <div className="grid grid-cols-2 gap-3 mb-6">
            {businessFeatures.map(({ icon: Icon, label }) => (
              <div key={label} className={`rounded-2xl p-4 ${isDark ? 'bg-black/30' : 'bg-white'}`}>
                <Icon size={22} className="text-[#81d8d0] mb-3" strokeWidth={1.7} />
                <p className={`text-sm font-medium ${isDark ? 'text-white' : 'text-[#1d1d1f]'}`}>{label}</p>
              </div>
            ))}
          </div>
          <div className="flex flex-wrap gap-2">
            {businessContent.targets.map((target) => (
              <span
                key={target}
                className={`px-3 py-2 rounded-full text-xs font-medium ${
                  isDark ? 'bg-white/8 text-[#CBD5E1]' : 'bg-white text-gray-600'
                }`}
              >
                {target}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default BusinessPreviewSection;
